export const COST_TYPE = {
  NOT_OFFERED: 'Not Offered',
  COPAY: 'Copay',
  COINSURANCE: 'Coinsurance',
};

export const COST_TYPE_LABELS = {
  [COST_TYPE.NOT_OFFERED]: 'Not Offered',
  [COST_TYPE.COPAY]: 'Copay',
  [COST_TYPE.COINSURANCE]: 'Coinsurance',
};
